import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeList, init, update } from "../../redux/actions/evaluationItem";
import Footer from "../common/Footer";
import Header from "../common/Header";
import { useSearchParams } from "react-router-dom";
import { getStickerId, GRADE_CODES } from "../common/constants";

export default function UpdateValuationItemMaster() {
  const [rows, setRows] = useState([]);
  const [age, setAge] = useState(""); 

  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const abolitionFlgValueTrue = useSelector(state => state.evaluationItem.abolitionFlgValues[1]);
  const [abolitionFlgLabelFalse, abolitionFlgLabelTrue] = useSelector(state => state.evaluationItem.abolitionFlgTexts);
  const itemRows = useSelector(state => state.evaluationItem.rows);
  const selectAge = useSelector(state => state.evaluationItem.age);
  const categoryValueOptions = useSelector(state => state.evaluationItem.categoryValueOptions);
  const evaluationList = useSelector(state => state.evaluationItem.evaluationList);

  const selectedList = useMemo(
    () => evaluationList.find(item => item.listId === age),
    [evaluationList, age]
  );

  const ratingCols = useMemo(() => {
    if (!selectedList || !selectedList.gradeRange) return [];

    const [start, end] = selectedList.gradeRange
      .split(',')
      .map(n => parseInt(n, 10));

    const codes = GRADE_CODES
      .slice(start - 1, end)
      .reverse();

    return codes.map(grade => {
      const codeIndex = GRADE_CODES.indexOf(grade);
      const stickerId = getStickerId(codeIndex);

      const fieldName = `ratingGrade${grade}`;

      return {
        field: fieldName,
        headerName: `評価等級${grade}`,
        editable: false,
        width: 100,
        headerClassName: "headerColor",
        renderCell: params => (
          <a
            href={`/UpdateSticker?listId=${age}` +
              `&itemId=${params.row.itemId}` +
              `&stickerFileName=${params.row[fieldName]}` +
              `&stickerId=${stickerId}`}
            rel="noopener noreferrer"
          >
            {params.row.itemName + grade}
          </a>
        )
      };
    });
  }, [selectedList, age]);

  const columns = useMemo(() => [
    { field: "itemId", headerName: "項目ID", width: 100, editable: true, headerClassName: "headerColor" },
    { field: "itemName", headerName: "項目名", width: 130, editable: true, headerClassName: "headerColor" },
    {
      field: "catagoryName",
      headerName: "カテゴリ名",
      type: "singleSelect",
      valueOptions: categoryValueOptions,
      renderCell: params =>
        <div>
          {categoryValueOptions.find(o => o.value === params.value)?.label}
        </div>,
      editable: true,
      width: 150,
      headerClassName: "headerColor"
    },
    { field: "outputOrder", headerName: "出力順", width: 100, editable: true, headerClassName: "headerColor" },
    ...ratingCols,
    {
      field: "abolition",
      headerName: "廃止",
      type: "singleSelect",
      valueOptions: [{ value: abolitionFlgValueTrue, label: abolitionFlgLabelTrue }],
      renderCell: params =>
        <div>
          {params.value === abolitionFlgValueTrue ? abolitionFlgLabelTrue : abolitionFlgLabelFalse}
        </div>,
      editable: true,
      width: 120,
      headerClassName: "headerColor"
    },
    {
      field: "registeredDate",
      headerName: "登録日時",
      type: "dateTime",
      width: 180,
      editable: false,
      headerClassName: "headerColor",
      renderCell: params =>
        <div>
          {params.value
            ? new Date(params.value).toLocaleString("ja-JP", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            })
            : ""}
        </div>
    },
    {
      field: "updatedDate",
      headerName: "更新日時",
      type: "dateTime",
      width: 180,
      editable: false,
      headerClassName: "headerColor",
      renderCell: params =>
        <div>
          {params.value
            ? new Date(params.value).toLocaleString("ja-JP", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            })
            : ""}
        </div>
    }
  ], [
    categoryValueOptions,
    abolitionFlgValueTrue,
    abolitionFlgLabelTrue,
    abolitionFlgLabelFalse,
    ratingCols,
    age
  ]);

  useEffect(() => {
    const urlAge = searchParams.get('selectAge');

    if (urlAge) {
      setAge(urlAge);
      dispatch(changeList(urlAge));
    } else {
      dispatch(init());
    }
  }, [dispatch, searchParams]);


  useEffect(() => {
    setRows(itemRows);
  }, [itemRows]);


  useEffect(() => {
    const urlAge = searchParams.get('selectAge');
    if (!urlAge && selectAge) {
      setAge(selectAge);
      setSearchParams({ selectAge: selectAge });
    }
  }, [selectAge, setSearchParams]);

  const handleChange = event => {
    const selectedValue = event.target.value;
    setSearchParams({ selectAge: selectedValue });
    dispatch(changeList(selectedValue));
    setAge(selectedValue);
  };

  const handleGridDataChange = params => {
    const { id, field, value } = params;
    setRows(prevData => {
      const newData = prevData.map(row => {
        if (row.id === id) {
          return { ...row, [field]: value };
        }
        return row;
      });
      return newData;
    });
  };

  const updateSubmit = () => {
    dispatch(update(rows));
  };

  return (
    <Box>
      <Header />
      <Container>
        <Box
          sx={{
            marginTop: 4,
            alignItems: "center",
            justifyContent: "center",
            margintBottom: 2
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            評価項目マスタ更新
          </Typography>
        </Box>
        <Box
          sx={{
            m: 1,
            display: "flex",
            flexDirection: "column",
            paddingLeft: 2
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            更新したい評価リストを選択してください
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <FormControl size="small" sx={{ minWidth: 180, bgcolor: "white", marginRight: "auto", mt: 2, ml: 8 }}>
            <InputLabel id="demo-simple-select-label">評価内容</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label="作業能力"
              onChange={handleChange}
            >
              {evaluationList.length !== 0 &&
                evaluationList.map(list =>
                  <MenuItem value={list.listId} key={list.listId}>
                    {list.listName}
                  </MenuItem>
                )}
            </Select>
          </FormControl>
          <Box sx={{ alignItems: "center", justifyContent: "center", m: 1 }}>
            <Container>
              <div
                style={{
                  height: "330px",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  overflowY: 'hidden'
                }}
              >
                <DataGrid
                  sx={{
                    bgcolor: "white",
                    "& .headerColor": {
                      backgroundColor: "#ffcc80"
                    }
                  }}
                  rows={rows}
                  columns={columns}
                  hideFooter={true}
                  onCellEditCommit={handleGridDataChange}
                />
              </div>
            </Container>
          </Box>
        </Box>
        <Container maxWidth="sm">
          <Stack sx={{}} direction="row" spacing={5} justifyContent="center">
            <Button variant="contained" onClick={updateSubmit} sx={{ bgcolor: "#82b1ff", width: "50%" }}>
              更新
            </Button>
          </Stack>
        </Container>

        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, display: "flex" }}>
          <Button variant="contained" size="medium" href="/AdminMenu" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}